﻿import {Component, Input} from "@angular/core";
import { Router} from "@angular/router";
import { Credentials, CredentialsResponse } from "../../models/login.model";
import { DataService } from "../../services/dataService";
import * as moment from 'moment';
import { Builder } from "protractor";
import { Validators } from "@angular/forms";

declare var window: any;
declare function displayAlert(): any;
@Component({
    selector: "jax-loginform",
    templateUrl: "./loginForm.component.html",
    host: { "(document: keyup)": "keyup($event)" }
})

export class LoginFormComponent {

    public credentials = new Credentials();
    public hasError = false;
    public validationMessage = "Incorrect login name or password";
    public currentUser: any;
    public loginCompleted:boolean=true;


    @Input()
    public userType: string;


    constructor(private dataService: DataService, private router: Router) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
             this.router.navigate(["dashboard"]);
        }
        this.loginCompleted = true;
        window.showAlert = false;
    }

    public signUp(value) {
        if (this.userType === "1") {
            this.router.navigate(["signup"]);
        } else {
            this.router.navigate(["emailverfiy"]);
        }
    }

    public forgotPassword() {
        if (this.userType === "1") {
            this.router.navigate(["forgotPassword"]);
        } else {
            this.router.navigate(["forgotPassword"]);
        }
    }

    public login() {
        this.dataService.redirectionStatus = 0;
        this.hasError = false;
        this.loginCompleted = false;
        if (!(this.credentials.loginName || this.credentials.password)) {
            this.validationMessage = "Please enter username and password";
            return;
        }

        if (!this.credentials.selected) {
           this.validationMessage = "Acknowledgement of the Confidentiality statement is required to proceed";
           this.hasError = true;
           this.loginCompleted = true;
           return;
        }

        let apimethod = "";
        if (this.userType == "1") {
            apimethod = "user/Login";
        } else {
            apimethod = "extuser/Login";
        }

        this.dataService.post(apimethod, JSON.stringify(this.credentials))
            .subscribe((s) => {
                    if (s && s.Succeeded) {
                        let ret = this.saveUser(s);
                        if (ret) {
                            this.hasError = false;
                            if (s.ForceChangePassword) {
                                this.clearUser();
                                this.router.navigate(["changepassword"]);
                            } else {
                                this.router.navigate(["dashboard"]);
                                if (s.PasswordExpirationNotification && !s.ForceChangePassword) {
                                    window.notificationDays = s.PasswordExpirationNotificationDays;
                                    window.expirationDateTime = moment(s.PasswordExpiresOnDateTime).format("MM/DD/YYYY [at] hh:mm A");
                                    window.showAlert = true;
                                   displayAlert();
                                }
                            }
                        } else {
                            this.hasError = true;
                            this.validationMessage = "Internal server error, please contact helpdesk";
                        }

                    } else {
                        this.hasError = true;
                        this.validationMessage = s.Message;
                    }
                    this.loginCompleted = true;
                },
                (error) => {
                    this.hasError = true;
                    this.loginCompleted = true;
                });
    }


    private saveUser(response:any):boolean {
        let user = response;
        if (user && user.Token) {
            localStorage.setItem("currentUser", JSON.stringify(user));
            return true;
        } else {
            return false;
        }
    }

    private clearUser() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.currentUser.AccessLevel = -1;
            this.currentUser.Department = -1;
            this.currentUser.LoginSucessful = 0;
            this.currentUser.RemovalRequestDeleteEnable = false;
            this.currentUser.RoleId = -1;
            this.currentUser.Security = "";
            this.currentUser.Succeeded = -1;
            this.currentUser.UploadEnable = false;
            this.currentUser.UserType = -1;
            this.currentUser.county = -1;
            localStorage.setItem("currentUser", JSON.stringify(this.currentUser));
        }
    }

    private keyup(event: KeyboardEvent): void {
        if (event.keyCode === 13 && (this.credentials.loginName && this.credentials.password)) {
            this.login();
        }
    }
}
